// extracted by mini-css-extract-plugin
export default {"profile":"myPage_profile__zW8v1"};